import {
    isBirthDateValid,
    isPasswordValid,
    isRUTValid
} from '@lib/utils/formValidators'
import { CHILE_PHONE_LENGTH } from '@lib/utils/chilePhone'
import { validate } from 'email-validator'
import { TFunction } from 'next-i18next/pages'
import { RegisterFormData, RegisterFormErrors } from '../types'

interface ValidateResponse {
    errors: RegisterFormErrors
    hasErrors: boolean
}

export const validateForm = (
    data: RegisterFormData,
    t: TFunction
): ValidateResponse => {
    const {
        email,
        firstName,
        lastName,
        phone,
        rut,
        birthday,
        password,
        confirmPassword,
        addShippingAddress,
        acceptTerms,
        region,
        comuna,
        address,
        addressNumber,
        addressPhone
    } = data

    const errors = {} as RegisterFormErrors

    if (!email) {
        errors.email = t('authErrors|Required')
    } else if (!validate(email)) {
        errors.email = t('authErrors|Invalid Email')
    }

    if (!firstName) {
        errors.firstName = t('authErrors|Required')
    }
    if (!lastName) {
        errors.lastName = t('authErrors|Required')
    }

    if (birthday && !isBirthDateValid(birthday)) {
        errors.birthday = t('authErrors|Invalid BirthDate')
    }

    if (!password) {
        errors.password = t('authErrors|Required')
    } else if (!isPasswordValid(password)) {
        errors.password = t('authErrors|Invalid Password')
    }

    if (!confirmPassword) {
        errors.confirmPassword = t('authErrors|Required')
    } else if (password !== confirmPassword) {
        errors.confirmPassword = t('authErrors|Invalid Confirm Password')
    }

    if (!phone) {
        errors.phone = t('authErrors|Required')
    } else if (phone.length !== CHILE_PHONE_LENGTH) {
        errors.phone = t('authErrors|Phone must have 9 numbers')
    }

    if (!rut) {
        errors.rut = t('authErrors|Required')
    } else if (!isRUTValid(rut)) {
        errors.rut = t('Invalid RUT')
    }

    if (!acceptTerms) {
        errors.acceptTerms = t('authErrors|Required')
    }

    if (addShippingAddress) {
        if (!region) {
            errors.region = t('authErrors|Required')
        }
        if (!comuna) {
            errors.comuna = t('authErrors|Required')
        }
        if (!address) {
            errors.address = t('authErrors|Required')
        }
        if (!addressNumber) {
            errors.addressNumber = t('authErrors|Required')
        }

        if (!addressPhone) {
            errors.addressPhone = t('authErrors|Required')
        } else if (addressPhone.length !== CHILE_PHONE_LENGTH) {
            errors.addressPhone = t('authErrors|Phone must have 9 numbers')
        }
    }

    return { errors, hasErrors: Object.keys(errors).length !== 0 }
}
